import isUndefined from "./isUndefined";

const getHost = () => {
  if (isUndefined(window)) return;

  return window.location.origin;
}

export default getHost;